<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Redemptions</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <!-- <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div> -->
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="redemptions">
  <div class="container redemptions-container">
    <div class="container-header no-bottom-border">
      <div class="text">Redemption-enabled Flows and Broadcasts</div>
      <div class="options">
        <button mat-icon-button [matMenuTriggerFor]="redemptionsMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant" #redemptionsMenu="matMenu">
          <button
            class="icon-btn-w-text"
            mat-menu-item
            (click)="exportToExcel()"
          >
            <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>

            <span>Export to Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="container-content">
      <table
        #redemptionsTable
        mat-table
        [dataSource]="redemptionsDataSource"
        matSort
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="launch_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Launch date</th>

          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.launch_date">
              {{ formatDate(row.launch_date) }}
            </ng-container>
            <ng-container *ngIf="!row.launch_date"> - </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="recipients">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Recipients</th>
          <td mat-cell *matCellDef="let row">
            {{ row.recipients ? row.recipients : "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="tracking_period_days">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Tracking window
          </th>
          <td mat-cell *matCellDef="let row">
            {{
              row.tracking_period_days
                ? row.tracking_period_days + " days"
                : "-"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="redemptions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Redemptions</th>
          <td mat-cell *matCellDef="let row">
            {{ row.redemptions ? row.redemptions : "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="redemptions_pct">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Redemption Pct
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.redemptions_pct ? row.redemptions_pct + "%" : "-" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="rank">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Redemption Rank
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.rank ? row.rank : "-" }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          class="clickable-row"
          [ngClass]="{ selected: row === currentRedemption }"
          *matRowDef="let row; columns: displayedColumns"
          (click)="onRedemptionSelected(row)"
        ></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage"
      (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>

  <div *ngIf="currentRedemption" class="container redemption-data-container">
    <div class="container-header no-bottom-border">
      <div class="text">Redemptions for {{ currentRedemption.name }}</div>
    </div>
    <div class="container-content">
      <div echarts [options]="redemptionChartOptions" class="line-chart"></div>
    </div>
  </div>
</div>
